// extracted by mini-css-extract-plugin
module.exports =  {"label":"a10a3f92e9--label--hIfaq","cursor_pointer":"a10a3f92e9--cursor_pointer--Pe1mY"};